import u from "./ghl-ui.es1589.js";
import p from "./ghl-ui.es1590.js";
import s from "./ghl-ui.es1586.js";
import f from "./ghl-ui.es1587.js";
import c from "./ghl-ui.es1588.js";
import n from "./ghl-ui.es1591.js";
import { Parser as l } from "./ghl-ui.es1670.js";
import { numericPatterns as h } from "./ghl-ui.es1672.js";
import { parseNDigits as v, parseNumericPattern as k } from "./ghl-ui.es1671.js";
import I from "./ghl-ui.es1674.js";
import d from "./ghl-ui.es1661.js";
var b = /* @__PURE__ */ function(m) {
  f(i, m);
  var o = c(i);
  function i() {
    var a;
    u(this, i);
    for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++)
      e[t] = arguments[t];
    return a = o.call.apply(o, [this].concat(e)), n(s(a), "priority", 100), n(s(a), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), a;
  }
  return p(i, [{
    key: "parse",
    value: function(r, e, t) {
      switch (e) {
        case "I":
          return k(h.week, r);
        case "Io":
          return t.ordinalNumber(r, {
            unit: "week"
          });
        default:
          return v(e.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, e) {
      return e >= 1 && e <= 53;
    }
  }, {
    key: "set",
    value: function(r, e, t) {
      return d(I(r, t));
    }
  }]), i;
}(l);
export {
  b as ISOWeekParser
};
